export default "__VITE_ASSET__q4k8EVP0__"